// import { HeaderGroupManager } from './header-group'

window.GeoLocation = {
  callGeo: function () {
    return fetch(`https://ip.ecom.umgapps.com/ip/lookup`)
      .then((response) => {
        return response.json()
      })
  },

  geoContent: function (countryName, countryISOCode) {
    const geoShow = document.querySelectorAll('[data-geo-show]')
    let itemList = ''
    for (const item of geoShow) {
      itemList = item.dataset.geoShow.split(',')
      if (itemList.includes(countryISOCode)) {
        item.classList.add('!block')
        // if (item.parentNode.parentNode?.classList.contains('section-soft-redirects')) {
        //   const headerGroupManager = HeaderGroupManager.getInstance()
        //   headerGroupManager.updateMeasurements()
        // }
      }
    }
    const geoHide = document.querySelectorAll('[data-geo-hide]')
    for (const item of geoHide) {
      itemList = item.dataset.geoHide.split(',')
      if (itemList.includes(countryISOCode)) {
        item.classList.add('!hidden')
      }
    }
    const geoCountryNameReplace = document.querySelectorAll('[data-geo-countryname-replace]')
    for (const item of geoCountryNameReplace) {
      item.outerHTML = countryName
    }
    const geoCountryIsoReplace = document.querySelectorAll('[data-geo-countryiso-replace]')
    for (const item of geoCountryIsoReplace) {
      item.outerHTML = countryISOCode
    }

    if (document.querySelector('dialog[data-modal="softRedirectPopup"]')) {
      const softRedirectPopup = document.querySelector('dialog[data-modal="softRedirectPopup"]')
      const toggleButton = document.getElementById('toggleVisibilityButton')
      let showPopup = true
      if (sessionStorage.getItem('_x_softRedirectVisible')) {
        const savedValue = sessionStorage.getItem('_x_softRedirectVisible')
        if (savedValue === 'false') showPopup = false
      }
      if (sessionStorage.getItem('softRedirectVisible')) {
        const savedValue = sessionStorage.getItem('softRedirectVisible')
        if (savedValue === 'false') {
          showPopup = false;
          softRedirectPopup.classList.remove('!block');
        }
      }
      if (showPopup === true && softRedirectPopup.classList.contains('!block')) softRedirectPopup.showModal()
    }
  },

  applyGeo: function (countryName, countryISOCode, city) {
    if (!Shopify.designMode) {
      Shopify.analytics.publish('geolocation_detected', {
        countryCode: countryISOCode,
        city: city
      })
    }
    this.geoContent(countryName, countryISOCode)
    window.countryISOCodeGlobal = countryISOCode
  },

  checkGeo: function () {
    this.callGeo()
      .then((response) => {
        const countryISOCode = response.countryISOCode
        const countryName = response.country
        const city = response.city
        this.applyGeo(countryName, countryISOCode, city)
      })
  }
}
window.addEventListener('load', function () {
  window.GeoLocation.checkGeo()
})